import api from './config';

// ── Políticas ──────────────────────────────────────────────────
export const getVacationPolicies    = async ()           => (await api.get('/vacations/policies')).data;
export const saveVacationPolicy     = async (data)       => (await api.post('/vacations/policies', data)).data;
export const deleteVacationPolicy   = async (id)         => (await api.delete(`/vacations/policies/${id}`)).data;
export const initDefaultPolicies    = async ()           => (await api.post('/vacations/policies/init-defaults')).data;

// ── Balance ────────────────────────────────────────────────────
export const getAllBalances          = async (year)       => (await api.get('/vacations/balances', { params: { year } })).data;
export const getEmployeeBalance     = async (empId, year)=> (await api.get(`/vacations/balance/${empId}`, { params: { year } })).data;

// ── Asignación ─────────────────────────────────────────────────
export const allocateVacations      = async (body)       => (await api.post('/vacations/allocate', body)).data;

// ── Ajuste manual ──────────────────────────────────────────────
export const adjustVacationBalance  = async (body)       => (await api.post('/vacations/adjust', body)).data;

// ── Historial ──────────────────────────────────────────────────
export const getVacationHistory     = async (params)     => (await api.get('/vacations/history', { params })).data;
export const getEmployeeHistory     = async (empId, year)=> (await api.get(`/vacations/history/${empId}`, { params: { year } })).data;

// ── Calendario ────────────────────────────────────────────────
export const getVacationCalendar    = async (year, month) => (await api.get(`/vacations/calendar/${year}/${month}`)).data;

// ── Nómina ─────────────────────────────────────────────────────
export const getVacationPayPreview  = async (periodo, quincena)   => (await api.get(`/vacations/payroll-preview/${periodo}`, { params: { quincena } })).data;
export const calcVacationPay        = async (empId, days, tipo = 'total', periodo = null) => (await api.get(`/vacations/pay-calc/${empId}`, { params: { days, tipo, ...(periodo && { periodo }) } })).data;
export const autoLoadVacationPay    = async (periodo, quincena, payroll_id) => (await api.post(`/vacations/payroll-auto/${periodo}`, { quincena, payroll_id })).data;
